<script type="text/javascript">
import { SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION } from "constants";

	import { createEventDispatcher } from "svelte"
	import { get } from "svelte/store"
	import LoadState from "../../Enums/LoadState";
	import MapStore from "../../Map/Store";
	import PortsStore from "./Store";

	export let ports = [];
	export let filterString = "";
	export let height = 300;

	let style = "height:"+height+"px;min-height:"+height+"px;";

	const dispatch = createEventDispatcher(); // update

</script>

<div class="ports-table-container mdc-elevation--z2" style={style}>
	<table class='svelte-table'>
		<thead>
			<tr>
				<th>Name</th>
				<th width="70">Country</th>
				<!-- <th width="70">Type</th> -->
				<th width="60"></th>
			</tr>
		</thead>
		<tbody>
			{#each ports as port (port.uniqId)}
				{#if (filterString.trim().length === 0 ||
					port.name.toLowerCase().indexOf(filterString.toLowerCase()) >= 0)}
					<tr>
						<td><a href="/" on:click|preventDefault={()=>{ PortsStore.actions.openPort(port); }}>{port.name}</a></td>
						<td>{port.country}</td>
						<!-- <td>{port.portTypeReadable}</td> -->
						<td>
							<button class="bg-info" style="font-size:12px;" on:click={()=>{ PortsStore.actions.gotoPort(port) }}>Goto</button>
						</td>
						<!-- <td>
							{#if get(port.loadState) === LoadState.LOADING}
								Loading...
							{:else}
								<button
									class={(get(port.visible)?"bg-primary":"bg-info")}
									style="font-size:12px;"
									on:click={()=>{
										port.visible.set(!get(port.visible));
										dispatch("update");
									}}
									>{get(port.visible)}</button>
							{/if}
						</td> -->
					</tr>
				{/if}
			{/each}
		</tbody>
	</table>
</div>
